import { Button } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useCallback, useMemo } from 'react';

/** A snackbar handler that provides different notification types. */
const useSnackbarHandler = () => {
  const { closeSnackbar, enqueueSnackbar } = useSnackbar();

  const toast = useCallback(
    (message: string, variant: 'error' | 'info' | 'success' | 'warning') => {
      enqueueSnackbar(message, {
        action: (key) => (
          <Button
            onClick={() => closeSnackbar(key)}
            variant="text"
            style={{ color: 'white' }}
          >
            Dismiss
          </Button>
        ),
        variant,
      });
    },
    [closeSnackbar, enqueueSnackbar],
  );

  const snackbarHandler = useMemo(
    () => ({
      error: (message: string) => toast(message, 'error'),
      info: (message: string) => toast(message, 'info'),
      success: (message: string) => toast(message, 'success'),
      warning: (message: string) => toast(message, 'warning'),
    }),
    [toast],
  );
  return snackbarHandler;
};

export default useSnackbarHandler;
